import React, { FC } from 'react';
import { AppBar, FormControl, Grid, MenuItem, Select, Toolbar } from '@material-ui/core';
import { useStyles } from './styles';
import { AngleDownIcon } from '../CustomIcons';
import { languages } from '../../utils';

interface Props {
  logo: any;
  selectedLocale: string;
  handleLocaleChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
}

export const UnauthorizedHeader: FC<Props> = ({ selectedLocale, logo, handleLocaleChange }) => {
  const classes = useStyles();

  return (
    <Grid container direction="row" className={classes.unathorizedHeader}>
      <AppBar position="sticky" className={classes.appBarShift}>
        <Toolbar className={classes.toolbar}>
          <Grid item className={classes.logo}>
            <img src={logo} alt="" className={classes.logoImg} />
          </Grid>
          <Grid className={classes.headerSpace} />
          <div>
            <FormControl variant="standard" className={classes.languageSelect}>
              <Select
                onChange={handleLocaleChange}
                renderValue={(value: any) => (
                  <div className={classes.languageItem}>
                    <span className={classes.languageSelectedItem}>{value.squareIcon}</span>
                    {value.label}
                  </div>
                )}
                autoWidth
                inputProps={{
                  IconComponent: AngleDownIcon,
                }}
                value={selectedLocale}
                disableUnderline
              >
                {languages.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    <span className={classes.languageSelectItem}>{item.squareIcon}</span>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </Toolbar>
      </AppBar>
    </Grid>
  );
};
